import React from 'react';
import { Box, Typography, Grid, Paper, Button } from '@mui/material';
import { ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { getTips } from '../utils/dashboardUtils';

/**
 * Dashboard ipuçları ve eğitimler bölümü
 */
const TipsSection = () => {
  const { t } = useTranslation();
  const tips = getTips(t);

  return (
    <Box className="tips-section">
      <Box className="tips-header">
        <Typography className="tips-title">
          Hızlı İpuçları ve Eğitimler
        </Typography>
        <Button 
          variant="text"
          endIcon={<ArrowForwardIcon />}
          sx={{
            textTransform: 'none',
            color: '#4158D0',
            '&:hover': {
              background: 'rgba(65, 88, 208, 0.05)',
            }
          }}
        >
          Tümünü Gör
        </Button>
      </Box>

      <Grid container spacing={3}>
        {tips.map((tip) => (
          <Grid item xs={12} md={4} key={tip.id}>
            <Paper 
              className="tip-card"
              elevation={0}
              sx={{
                '--tip-color': tip.color,
                '--tip-bg': tip.bg,
                cursor: 'pointer'
              }}
            >
              <Box className="tip-icon">
                {tip.icon}
              </Box>
              <Typography className="tip-title">
                {tip.title}
              </Typography>
              <Typography className="tip-description">
                {tip.description}
              </Typography>
              <Typography className="tip-link">
                Daha Fazla Bilgi
                <ArrowForwardIcon fontSize="small" />
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default TipsSection;
